<div class="container">
    <div class="head-wrapper">
        <h2>CountDown</h2>
    </div>
    <div class="content-wrapper">
        <div class="c-card" (click) = "onCustom()">
            <div class="card-text">
                <p>Custom count-down</p>
            </div>
            <div class="card-img">
                <img src="../../../assets/img/Time.png" alt="">
            </div>
        </div>
        <div class="card">
            <div class="card-img">
                <img src="../../../assets/img/earth.png" alt="earth">
            </div>
            <div class="card-text">
                <p>Earth's day Countdown</p>
            </div>
            <app-timer [targetDate]="earthDayDate"></app-timer>
        </div>
        <div class="card">
            <div class="card-img">
                <img src="../../../assets/img/ocean.png" alt="ocean">
            </div>
            <div class="card-text">
                <p>Ocean's Day Countdown</p>
            </div>
            <app-timer [targetDate]="oceanDayDate"></app-timer>
        </div>

        <div class="card">
            <div class="card-img">
                <img src="../../../assets/img/yoga.png" alt="yoga">
            </div>
            <div class="card-text">
                <p>Yoga's Day Countdown</p>
            </div>
            <app-timer [targetDate]="yogaDayDate"></app-timer>
        </div>

        <div class="card">
            <div class="card-img">
                <img src="../../../assets/img/wildlife.png" alt="deer">
            </div>
            <div class="card-text">
                <p>Wildlife's Day Countdown</p>
            </div>
            <app-timer [targetDate]="wildlifeDayDate"></app-timer>

        </div>

        <div class="card">
            <div class="card-img">
                <img src="../../../assets/img/peace.png" alt="peace">
            </div>
            <div class="card-text">
                <p>Peace's Day Countdown</p>
            </div>
            <app-timer [targetDate]="peaceDayDate"></app-timer>
        </div>

    </div>
</div>